const state = {
  indexs: [],
  homes: []
};

const getters = {
  getIndexs(state) {
    return state.indexs;
  },
  getHomes(state) {
    return state.homes;
  }
};

const mutations = {
  getIndex(state, index) {
    state.indexs = index;
  },
  getHome(state, home) {
    state.homes = home;
  }
};

const actions = {
  indexs({
    commit
  }, getHome) {
    commit('getIndex', getIndex); // 引用 userStatus 方法，并传值
  },
  home({
    commit
  }, getHome) {
    commit('getHome', getHome); // 引用 userStatus 方法，并传值
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/module/home.js